import { isNil } from "lodash-es";

/**
 * Preprocesses a form field value for display in a text input.
 * Handles null/undefined values, converts numbers to strings (avoiding scientific notation),
 * and optionally removes leading "1" or "+1" from phone numbers.
 */
export function preprocessValueForTextField({
  value,
  defaultValue,
  onChange,
  removeLeading1 = false,
}: {
  value: string | number | null | undefined;
  defaultValue: string | undefined;
  removeLeading1?: boolean;
  onChange: (value: string) => void;
}): string {
  if (isNil(value)) {
    return defaultValue ?? "";
  }

  // If value is a number (not already a string), format it to avoid scientific notation
  // This is especially important for very small numbers like 7.6e-11
  if (typeof value === "number") {
    // For very small numbers, use toFixed with high precision to avoid scientific notation
    if (Math.abs(value) < 0.001 && value !== 0) {
      return value.toFixed(15).replace(/\.?0+$/, ""); // Remove trailing zeros
    }
    return String(value);
  }

  if (removeLeading1 && (value.startsWith("+1") || value.startsWith("1"))) {
    value = value.replace(/^(\+1|1)/, "");
    onChange(value);
  }

  return value;
}
